import "./Service_pages.scss";
import img from "./services/clear_aligne.png"; // Replace with your actual image path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaUserMd, FaHeart, FaShieldAlt, FaClinicMedical, FaLaptopMedical, FaThumbsUp } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdOutlineVisibility, MdScanner } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const ClearAligners = () => {

    const types = [
        {
            title: "Invisalign & Premium Brands",
            icon: <MdOutlineStarPurple500 />,
            desc: "World-class transparent aligner systems that use patented SmartTrack material for predictable, comfortable, and efficient tooth movement.",
        },
        {
            title: "Custom Aligner Solutions",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Tailored trays designed through precise 3D digital planning to correct crowding, spacing, and mild to moderate bite issues nearly invisibly.",
        },
        {
            title: "Teen-Specific Aligners",
            icon: <FaHeart />,
            desc: "Designed specifically for growing smiles, these aligners feature compliance indicators to help teenagers stay on track with their daily wear time.",
        },
        {
            title: "Digital Orthodontics",
            icon: <MdScanner />,
            desc: "Using advanced intraoral scanners to create a 3D map of your mouth, eliminating the need for messy traditional impressions.",
        },
    ];

    const disadvantages = [
        {
            title: "Strict Compliance Required",
            description: "Success depends on wearing the trays for 20–22 hours daily; failure to do so can delay results.",
        },
        {
            title: "Removability Management",
            description: "Because they are removable, they can be misplaced or lost if not stored properly in their protective case.",
        },
        {
            title: "Initial Pressure",
            description: "Patients may feel mild pressure or discomfort for 1-2 days when switching to a new set of trays in the series.",
        },
        {
            title: "Limited for Complex Cases",
            description: "Extremely severe jaw misalignments or complex orthodontic issues may still require traditional braces for effective correction.",
        },
        {
            title: "Maintenance Ritual",
            description: "Requires consistent cleaning of trays and brushing after every meal before re-inserting to prevent staining or decay.",
        },
    ];

    const benefits = [
        {
            category: "Aesthetics",
            benefit: "Nearly Invisible Appearance",
            description: "Transparent medical-grade plastic makes them discreet and ideal for professionals and socially active teens.",
        },
        {
            category: "Comfort",
            benefit: "Comfortable Smooth Fit",
            description: "Smooth plastic material reduces irritation to the gums and cheeks, unlike sharp metal brackets and wires.",
        },
        {
            category: "Lifestyle",
            benefit: "Removable Convenience",
            description: "Easily removed for eating, drinking, and special occasions, offering flexibility traditional braces cannot match.",
        },
        {
            category: "Hygiene",
            benefit: "Improved Oral Hygiene",
            description: "Allows for normal brushing and flossing since there are no fixed obstructions, reducing the risk of plaque buildup.",
        },
        {
            category: "Convenience",
            benefit: "Fewer Dental Visits",
            description: "Typically requires fewer clinical adjustments and shorter appointments compared to metal braces.",
        },
        {
            category: "Predictability",
            benefit: "Digital Treatment Planning",
            description: "Advanced software allows you to see a digital preview of your final smile before the treatment even begins.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Orthodontists',
            description: 'Our clinic features specialists with advanced training in digital aligner therapy for predictable results.'
        },
        {
            icon: <FaLaptopMedical />,
            title: 'Advanced Digital Scanners',
            description: 'We use high-precision 3D scanners and CBCT imaging for a highly accurate and comfortable diagnostic phase.'
        },
        {
            icon: <MdOutlineVisibility />,
            title: 'Personalized Planning',
            description: 'Every aligner journey is custom-designed using AI-powered software to match your unique dental structure.'
        },
        {
            icon: <FaThumbsUp />,
            title: 'Patient-Friendly Care',
            description: 'We prioritize your comfort throughout the process, from the first scan to the final retention phase.'
        },
        {
            icon: <FaShieldAlt />,
            title: 'Comprehensive Services',
            description: 'From simple spacing issues to moderate bite correction, we offer full-spectrum orthodontic solutions under one roof.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Modern HSR Facility',
            description: 'A hygienic, state-of-the-art environment conveniently located for residents of HSR Layout and surrounding areas.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Clear Aligners in HSR Layout | Invisalign & Teeth Straightening Bengaluru</title>
                    <meta
                        name="description"
                        content="Achieve a straighter smile with Clear Aligners in HSR Layout. Kosmix Dental Clinic offers nearly invisible, comfortable, and removable orthodontic solutions."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/clear-aligners-in-hsr-layout"
                    />
                </Helmet>

                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Clear Aligners in HSR Layout, Bengaluru
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Clear Aligner Treatment" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                A straight and well-aligned smile not only improves appearance but also enhances oral health and confidence.
                                <strong> Clear aligners</strong> have become the most popular orthodontic treatment for those who want to
                                straighten their teeth without the visibility and discomfort of traditional braces.
                            </p>
                            <p>
                                At Kosmix Dental Clinic in HSR Layout, Bengaluru, we provide advanced clear aligner treatments designed
                                to gently move teeth into their ideal position. Using modern digital technology, our specialists help
                                you achieve a beautifully aligned smile with nearly invisible aligners.
                            </p>
                            <p>
                                Perfect for teenagers and adults, these removable trays allow you to maintain your daily lifestyle and
                                oral hygiene without the major restrictions of metal wires.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What Are Clear Aligners?" />
                    <div className="text_first" >
                        <p1>
                            Clear aligners are custom-made orthodontic appliances used to straighten teeth and correct bite problems. Made from transparent medical-grade plastic, they apply gentle pressure sequentially. They are highly effective for treating crooked teeth, gaps, overbites, underbites, and crowding without the "metal-mouth" look.
                        </p1>
                    </div>
                </div>

                <section className="importance-section">
                    <div className="content">
                        <h2 className="section-title" data-aos="fade-up">Clear Aligners vs. Traditional Braces</h2>
                        <p1 className="text_first" data-aos="fade-up" data-aos-delay="100">
                            Choosing between aligners and braces depends on your lifestyle and dental needs. Here is how they compare:
                        </p1>
                    </div>

                    <div className="compare-row-container" data-aos="fade-up">
                        <div className="compare-header-row">
                            <div className="compare-feature">Feature</div>
                            <div className="compare-aligners">Clear Aligners</div>
                            <div className="compare-braces">Traditional Braces</div>
                        </div>
                        <div className="compare-data-row">
                            <div className="compare-feature">Appearance</div>
                            <div className="compare-aligners">Nearly invisible</div>
                            <div className="compare-braces">Visible metal brackets</div>
                        </div>
                        <div className="compare-data-row">
                            <div className="compare-feature">Comfort</div>
                            <div className="compare-aligners">Smooth plastic trays</div>
                            <div className="compare-braces">Metal wires and brackets</div>
                        </div>
                        <div className="compare-data-row">
                            <div className="compare-feature">Removability</div>
                            <div className="compare-aligners">Removable</div>
                            <div className="compare-braces">Fixed to teeth</div>
                        </div>
                        <div className="compare-data-row">
                            <div className="compare-feature">Oral Hygiene</div>
                            <div className="compare-aligners">Easier to maintain</div>
                            <div className="compare-braces">More difficult to clean</div>
                        </div>
                        <div className="compare-data-row">
                            <div className="compare-feature">Food Restrictions</div>
                            <div className="compare-aligners">Minimal</div>
                            <div className="compare-braces">Certain foods restricted</div>
                        </div>
                    </div>
                </section>

                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Digital Orthodontic Planning" />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Advanced Technology for Your Smile</h2>
                            <p style={{ color: 'black' }}>
                                At <strong>Kosmix Dental Clinic</strong>, we utilize high-end digital workflows to ensure your aligner treatment is precise and comfortable.
                            </p>

                            <div className="precision-tools-modern" data-aos="fade-up" data-aos-delay="400">
                                <h3 className="tools-title">Our Precision Tools</h3>
                                <div className="tools-grid">
                                    <div className="tool-box">
                                        <div className="tool-icon">
                                            <span className="emoji">🦷</span>
                                        </div>
                                        <div className="tool-text">
                                            <h4>Digital Intraoral Scanners</h4>
                                            <p>Captures precise 3D models of your teeth instantly for a perfect fit.</p>
                                        </div>
                                    </div>
                                    <div className="tool-box">
                                        <div className="tool-icon">
                                            <span className="emoji">💻</span>
                                        </div>
                                        <div className="tool-text">
                                            <h4>3D Treatment Software</h4>
                                            <p>Maps out each tooth movement so you can see your results before you start.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p style={{ color: 'black' }}>
                                Clear aligners are suitable for both <strong>Adults</strong> seeking a professional look and
                                <strong> Teens</strong> who want to keep up with their active lifestyle without the hassle of broken wires.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="crown-types-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="The Aligner Advantage" />
                        <p1 className="text_first">
                            Our clinic offers various aligner systems to match your specific clinical requirements and budget.
                        </p1>
                    </div>

                    <div className="crown-grid">
                        {types.map((item, idx) => (
                            <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                <div className="icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="modern-process-section" style={{ overflowX: 'hidden' }}>
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="How Clear Aligners Work" />
                        <p className="text_first">
                            A carefully planned, step-by-step process to transform your smile:
                        </p>
                    </div>

                    <div className="modern-process-timeline">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <div className="process-content" data-aos="fade-up">
                                <span className="process-icon">🩺</span>
                                <h3>Initial Consultation</h3>
                                <p>Evaluating teeth and bite alignment using 3D digital scans or impressions to create your custom plan.</p>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="process-number">02</div>
                            <div className="process-content" data-aos="fade-up" data-aos-delay="100">
                                <span className="process-icon">📊</span>
                                <h3>Digital Planning</h3>
                                <p>Using advanced software to design the step-by-step movement of every individual tooth.</p>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="process-number">03</div>
                            <div className="process-content" data-aos="fade-up" data-aos-delay="200">
                                <span className="process-icon">🛠️</span>
                                <h3>Custom Fabrication</h3>
                                <p>A complete series of custom aligner trays are fabricated specifically for your dental anatomy.</p>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="process-number">04</div>
                            <div className="process-content" data-aos="fade-up" data-aos-delay="300">
                                <span className="process-icon">✨</span>
                                <h3>Wearing the Trays</h3>
                                <p>Trays are switched every 1–2 weeks and must be worn for 20–22 hours daily for optimal results.</p>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="process-number">05</div>
                            <div className="process-content" data-aos="fade-up" data-aos-delay="400">
                                <span className="process-icon">📅</span>
                                <h3>Progress Monitoring</h3>
                                <p>Regular check-ins with our orthodontist to ensure your teeth are moving correctly as planned.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="advantages-section">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Caring for Your Aligners" />
                        <p1 className="text_first">
                            Proper maintenance is essential to ensure successful treatment and oral health:
                        </p1>
                    </div>

                    <div className="advantages-grid">
                        {[
                            { title: "Clean Daily", desc: "Use lukewarm water to rinse. Avoid hot water as it can deform the plastic." },
                            { title: "Brush & Floss", desc: "Always clean your teeth before re-inserting aligners to prevent decay." },
                            { title: "Safe Storage", desc: "Always place aligners in their protective case when not in your mouth." },
                            { title: "No Eating with Trays", desc: "Remove trays before eating or drinking anything other than plain water." },
                        ].map((item, index) => (
                            <div key={index} className="advantage-card" data-aos="fade-up" data-aos-delay={index * 100}>
                                <FaCheckCircle className="advantage-icon" />
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Analysis of Clear Aligner Benefits</h2>
                        </div>
                        <div className="table-responsive">
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Advantage Category</th>
                                        <th>Specific Benefit</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                <section className="considerations-modern-section" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Considerations & Expectations" />
                        <p1 className="text_first">
                            While highly effective, aligners require commitment to achieve your ideal smile:
                        </p1>
                    </div>

                    <div className="considerations-list-container">
                        {disadvantages.map((item, index) => (
                            <div key={index} className="consideration-row" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="row-icon-wrapper">
                                    <FaCheckCircle className="row-icon" />
                                </div>
                                <div className="row-text">
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="pricing-section" data-aos="fade-up">
                    <div className="pricing-content">
                        <div className="text-area">
                            <div className="content" data-aos="fade-up">
                                <SectionTitle title="Treatment Duration & FAQs" />
                                <p>
                                    Most treatments last <strong>6 to 18 months</strong>, depending on the severity of misalignment and your compliance.
                                </p>
                                <p>
                                    <strong>Are they painful?</strong> You may feel mild pressure when switching trays, but they are significantly more comfortable than wires.
                                    <strong>Will it affect speech?</strong> Some notice a slight lisp for the first few days, which resolves quickly as you adapt.
                                </p>
                            </div>
                        </div>

                        <div className="price-cards">
                            <div className="price-card">
                                <div className="tag">Suitability</div>
                                <h3 className="price">Teens & Adults</h3>
                                <p className="desc">Discreet solutions for all ages</p>
                                <ul className="details">
                                    <li>● Professional Appearance</li>
                                    <li>● Maintain Normal Lifestyle</li>
                                    <li>● Confidence Boosting</li>
                                </ul>
                            </div>

                            <div className="price-card premium">
                                <div className="tag premium-tag">Efficiency</div>
                                <h3 className="price">6–18 Months</h3>
                                <p className="desc">Average timeline for completion</p>
                                <ul className="details">
                                    <li>● Predictable Tooth Movement</li>
                                    <li>● Digital Progress Tracking</li>
                                    <li>● Effective Correction</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="why-kosmix-timeline">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix for Clear Aligners in HSR Layout?" />
                        <p1 className="text_first">
                            Our reputation as a trusted provider in Bengaluru is built on a foundation of technology and patient satisfaction:
                        </p1>
                    </div>
                    <div className="timeline">
                        {reasons.map((reason, index) => (
                            <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                                <div className="timeline-icon">{reason.icon}</div>
                                <div className="timeline-content">
                                    <h3>{reason.title}</h3>
                                    <p style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
                                        {reason.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>
                            Achieve Your Dream Smile <span>Today!</span>
                        </h2>
                        <p>
                            Discover the modern way to straighten teeth with comfort and convenience. Schedule your aligner consultation at Kosmix Dental Clinic.
                        </p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Aligner Consultation</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default ClearAligners;